import styled from 'styled-components';

const Backdrop = styled.div`
  overflow: scroll;
  background-color: #fff;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  background-color: rgba(255, 255, 255, 0.94);
`;

const ModalMain = styled.div`
  margin: 0px auto;
  width: 1100px;
  height: auto;
  border-radius: 0.25rem;
  box-shadow: rgb(0 0 0 / 20%) 0px 0px 16px 0px;
  z-index: 2000;
  background-color: rgb(255, 255, 255);
  top: 20%;
  position: relative;
  left: 0;
`;

const ModalInner = styled.div`
  display: flex;
  flex-flow: column;
  -webkit-box-pack: justify;
  justify-content: space-between;
  height: 100%;
`;

const ModalMessageMain = styled.div`
  height: 100%;
  display: flex;
  flex-flow: column;
  -webkit-box-pack: justify;
  justify-content: space-between;
  padding: 3rem;
`;

const ModalCancel = styled.div`
  float: right;
  padding: 1rem 1rem 0px 0px;
  position: absolute;
  right: 0%;
  top: 0%;
`;

const ModalHeading = styled.div`
  overflow-wrap: break-word;
  color: rgb(42, 44, 46);
  font-weight: 400;
  font-size: 2rem;
  color: rgb(75, 40, 109);
  line-height: 1.4;
  letter-spacing: -0.6px;
  margin-bottom: 1rem;
`;

export {
  Backdrop,
  ModalMain,
  ModalInner,
  ModalMessageMain,
  ModalCancel,
  ModalHeading
};
